export default {
  title: 'Serviços',
  description: 'Gerencie os serviços que existem no seu website.',
  labels: {
    new: 'Novo Serviço',
  },
  form: {
    title: 'Cadastro de serviço'
  },
  groups: {
    filter: 'Filtro',
    generalData: 'Dados gerais',
  },
  fields: {
    content: 'Conteúdo',
    is_draft: 'Rascunho',
    is_published: 'Publicado',
    language: 'Idioma',
    layout: 'Layout',
    max_depth: 'Limite de itens',
    name: 'Nome do serviço',
    page_type: 'Tipo de página',
    plan: 'Plano',
    preview:'Preview',
    slug: 'Slug',
    status: 'Status',
    url: 'URL',
    website: 'Website',
  }
};
